<!-- 产品类别 -->
<template>
  <BaseFormItem
    class="board_type"
    :label="fields.label"
    :labelTips="fields.labelTips"
  >
    <BaseRadioGroup v-model="val" @change="handleEmit">
      <el-radio-button
        class="board_type__radio"
        v-for="item in fields.options"
        :key="item.value"
        :label="item.value"
        @click.native.prevent="handleItemClick(item.value)"
      >
        {{ item.label }}
        <img 
          v-if="item.value == 'CEM-1'"
          class="board_type__radio__new" 
          :src="require('@@/assets/img/icons/icon_new.png')" 
        />
      </el-radio-button>
    </BaseRadioGroup>
  </BaseFormItem>
</template>

<script>
import { isMyCenterSite } from '@@/utils/is'
import { targetSelfWindow } from '@@/utils/triggerParent'
import { getFR4Fields } from '@@/utils/getFields'

export default {
  props: {
    value: {
      type: String,
      default: 'FPC'
    },
  },
  data() {
    return {
      val: this.value
    }
  },
  computed: {
    fields() {
      return getFR4Fields('board_type')
    },
  },
  watch: {
    value(newVal) {
      // this.val = newVal
      this.handleItemClick(newVal)
    },
  },
  methods: {
    handleEmit() {
      const val = this.val
      this.$emit('input', val)
      this.$emit('change', val)
    },
    handleItemClick(board_type) {
      if (board_type === 'FPC') {
        this.val = board_type
        this.handleEmit()
      } else {
        // 用户中心站点(DFM)
        if (isMyCenterSite) {
          targetSelfWindow({ path: '/orders/pcb/quote', query: { board_type } })
        } else {
          // FR-4 || ROGERS 跳转到新版计价页
          const path = ['FR-4', 'ROGERS'].includes(board_type) ? `/quote` : `/quote_new`
          // 新窗口打开
          window.open(`${path}?board_type=${board_type}`)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.board_type {
  margin-top: 15px;
}
.board_type__radio {
  position: relative;
  .board_type__radio__new {
    position: absolute;
    top: -10px;
    right: 6px;
  }
}
</style>